import moment from "moment";

export const getStatusColor = (status: string) => {
  switch (status) {
    case "In": return "bg-green-500";
    case "Out": return "bg-gray-400";
    case "Pending": return "bg-orange-500";
    case "Rejected": return "bg-red-500";
    default: return "bg-gray-400";
  }
};

export const getDuration = (signedIn?: string, signedOut?: string) => {
  if (!signedIn || !signedOut) return "-";
  const diff = moment.duration(moment(signedOut).diff(moment(signedIn)));
  const hours = diff.hours();
  const minutes = diff.minutes();
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};
